<ion-content>
	<div class="justify-center align-middle items-center text-center">
		<ion-spinner name="dots"></ion-spinner>
	</div>
</ion-content>
